/** Must match `RequestPayloadTooLargeExceptionHandler.RequestPayloadTooLargeCode` on the Admin API. */
export const REQUEST_PAYLOAD_TOO_LARGE = {
  code: "RequestPayloadTooLarge",
  status: 413,
} as const;
export const REQUEST_BODY_TOO_LARGE_FRAGMENT = "request body too large";
export const MAX_REQUEST_BODY_SIZE_FRAGMENT = "max request body size";
export const SAVE_ERROR_PROPERTY_NAME = "000";
